module.exports = __webpack_public_path__ + "static/media/logo-white.5eb91029.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-white.svg
// module id = 523
// module chunks = 1